import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Menu from './SecondaryNavDesktopMenu';

import * as styles from './SecondaryNavDesktop.module.less';

const SecondaryNavDesktopLink = ({ childItems, path, text }) => {
  const hasChildren = childItems && childItems.length > 0;
  return (
    <li
      className={classnames(styles.linkNav, {
        [styles.hasChildren]: hasChildren,
      })}
    >
      <a className={styles.link} href={path || undefined}>
        {text}
      </a>
      {hasChildren && <Menu links={childItems} />}
    </li>
  );
};

SecondaryNavDesktopLink.propTypes = {
  childItems: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string,
    })
  ),
  path: PropTypes.string,
  text: PropTypes.string,
};

SecondaryNavDesktopLink.defaultProps = {
  childItems: [],
  path: '',
  text: '',
};

export default SecondaryNavDesktopLink;
